<template>
	<div class="coverageNeeds">
		<div class='row no-gutters'>
			<div class='col'>
				<div class='toggleBox'>
					<label>
						<input v-model='wantsMedical' id='wantsMedical' role='checkbox' type='checkbox'><span class="toggle-label">{{$t("text.page2_input2")}}</span>
					</label>
				</div>
			</div>
			<div class='col-auto'>
				<button class="moreHelp" style='margin-left: 10px;' @click="openTooltip($t('text.page2_tooltip3'))" :aria-label="$t('text.moreinformation') + $t('text.page2_input2')">
					<img src="../assets/images/helpIcon_outline.svg" alt="" />
				</button>
			</div>
		</div>
		<div class='row no-gutters'>
			<div class='col'>
				<div class='toggleBox'>
					<label>
						<input v-model='wantsCancellation' id='wantsCancellation' type='checkbox'><span class="toggle-label">{{$t("text.page2_input1")}}</span>
					</label>
				</div>
			</div>
			<div class='col-auto'>
				<button class="moreHelp" v-if='this.$store.state.site==="cibc"' style='margin-left: 10px;' @click="openTooltip($t('text.page2_tooltip2'))" :aria-label="$t('text.moreinformation') + $t('text.page2_input1')">
					<img src='../assets/images/helpIcon_outline.svg' alt="" />
				</button>
				<button class="moreHelp" v-else href='javascript:void(0);' style='margin-left: 10px;' @click="openTooltip($t('text.page2_tooltip2nm'))" :aria-label="$t('text.moreinformation') + $t('text.page2_input1')">
					<img src='../assets/images/helpIcon_outline.svg' alt="" />
				</button>
			</div>
		</div>
		<br />
		<div class='row'>
			<div class="info-callout-box">
				<span v-if='this.$store.state.site==="cibc"' v-html="$t('text.page1_existingCoverage')" style="width: 100%; min-height: 20px; height: auto;  font-size: 13px; line-height: 150%; letter-spacing: 0; color: #6F6F6F;"></span>
				<span v-else v-html="$t('text.page1_existingCoveragenm')" style="width: 100%; min-height: 40px; height: auto; font-size: 13px; line-height: 150%; letter-spacing: 0; color: #6F6F6F;"></span>
			</div>
		</div>

	</div>
</template>

<style>
	.toggleBox input:checked + span {
		background-color: #333333 !important;
		color: #fff;
	}

	/*Wrapper*/
	.toggleBox span {
		background-color: #FFFFFF;
		border: 1px solid #606366;
		line-height: 22px;
		width: 100%;
		margin: 0;
		display: flex;
		align-items: center;
		border-radius: 12px;
		max-width: 1160px;
		height: 62px;
		gap: 14px;
		color: #333333;
		padding: 14px 15px 14px 52px;
		border-radius: 12px;
	}

	.toggleBox label {
		display: flex;
		align-items: center;
		width: 100%;
		cursor: pointer;
	}
		.toggleBox label input {
			opacity: 1;
			border-radius: 4px;
			border-width: 1px;
			line-height: 140%;
			color: #333333;
			letter-spacing: 0%;
			border: 1px #BBBCBC;
			font-size: 16px;
			font-weight: 500;
			width: 1084px;
			height: 22px
		}

	.toggleBox input[type="checkbox"] {
		position: absolute;
		left: 20px;
		z-index: 1;
		width: 19px;
		height: 19px;
		transform: scale(1.2);
		border: 1px solid #BBBCBC;
	}

	.toggleBox input:hover + span {
		background-color: #EEEEEE;
	}

	.coverageNeeds > .row > .col-auto {
		display: flex;
		align-items: center;
	}

	.info-callout-box {
		width: 100%;
		max-width: 1200px;
		min-height: 122px;
		height: auto;
		padding: 24px;
		border: 1px solid #BBBCBC;
		border-radius: 2px;
		opacity: 1;
		margin-left: 15px;
		margin-right: 15px;
		background: #FFFFFF;
		padding-bottom: 15px
	}
	.redesignedPage2 .info-callout-box {
		padding-bottom: 24px;
	}
	.redesignedPage2 .coverageNeeds .toggleBox label {
		margin: 0;
	}
	.redesignedPage2 .coverageNeeds > .row.no-gutters + .row.no-gutters {
		margin-top: 16px;
	}
	.redesignedPage2 .coverageNeeds > br {
		display: none;
	}
	.redesignedPage2 .coverageNeeds > .row:not(.no-gutters) {
		margin-top: 32px;
	}
	.redesignedPage2 .info-callout-box p {
		margin: 0;
	}
	.redesignedPage2 .info-callout-box p + p {
		margin-top: 14px;
	}
	@media (max-width: 767.98px) {
		.redesignedPage2 .coverageNeeds .toggleBox span {
			height: 72px;
		}
		.redesignedPage2 .coverageNeeds > .row:not(.no-gutters) {
			margin-top: 24px;
		}
		.redesignedPage2 .info-callout-box {
			padding: 16px;
		}
		.redesignedPage2 .info-callout-box p + p {
			margin-top: 16px;
		}
	}
</style>

<script>
	import { validationRules } from "../utils/validation_rules.js";
	import { validateForm, validateField } from "../utils/validation.js";
	import bus from "../utils/bus.js";

	export default {
		computed: {
			wantsCancellation: {
				get() {
				},
				set() {
					this.proceedButton();
				}
			},
			wantsMedical: {
				get() {

				},
				set() {
					this.proceedButton();
				}
			}
		},
		methods: {
			proceedButton() {
				if (document.getElementById("wantsCancellation").checked || document.getElementById("wantsMedical").checked) {
					document.getElementById("nav_next_disabled").classList.add("d-none");
					document.getElementById("nav_next_enabled").classList.remove("d-none");
				}
				else {
					document.getElementById("nav_next_disabled").classList.remove("d-none");
					document.getElementById("nav_next_enabled").classList.add("d-none");
				}
			},
			openTooltip(text) {
				document.getElementById("keywordBody").innerHTML = text;
				this.$nextTick(() => {
					document.getElementById("keywordBody").focus();
				});
				bus.$emit("openModal");
			}
		},
		mounted() {
			// If this session already has a policy number, reset the session
			if (this.$store.state.policyNumber !== "") { location.reload(); }

			// Focus stepTitle for accessibility.
			this.$nextTick(() => {
				document.getElementById("stepTitle").focus();
			});

			// Set initial state of checkboxes.
			if (this.$store.state.wantsCancellation === true) {
				document.getElementById("wantsCancellation").checked = true;
			}
			if (this.$store.state.wantsMedical === true) {
				document.getElementById("wantsMedical").checked = true;
			}

			// Set listeners on checkboxes to mimic focus
			const wantsCancellation = document.getElementById("wantsCancellation");
			const wantsMedical = document.getElementById("wantsMedical");

			if (wantsCancellation && wantsCancellation.nextSibling) {
				wantsCancellation.addEventListener("focus", (event) => {
					event.target.nextSibling.classList.add("isFocused");
				});
				wantsCancellation.addEventListener("blur", (event) => {
					event.target.nextSibling.classList.remove("isFocused");
				});
				wantsCancellation.nextSibling.addEventListener("mouseout", (event) => {
					event.target.classList.remove("isFocused");
				});
			}

			if (wantsMedical && wantsMedical.nextSibling) {
				wantsMedical.addEventListener("focus", (event) => {
					event.target.nextSibling.classList.add("isFocused");
				});
				wantsMedical.addEventListener("blur", (event) => {
					event.target.nextSibling.classList.remove("isFocused");
				});
				wantsMedical.nextSibling.addEventListener("mouseout", (event) => {
					event.target.classList.remove("isFocused");
				});
			}

			this.proceedButton();

		},
	};
</script>
